module.exports = __webpack_public_path__ + "img/CAL-UHF-Zubehörkoffer_transparent_Var1.890d6753.webp";